import React from 'react';

import {
  ConnectorSizing,
  SharedDomainParams,
  StraightLineLinkerDomainVisualization,
} from 'antibodies/AntibodyTypedefs';

import AntibodyComponentPopover from './AntibodyComponentPopover';

export type AntibodyStraightLineLinkerProps = SharedDomainParams & {
  /* The color of the linker */
  color: string;
  domainVisualization: StraightLineLinkerDomainVisualization;
  connectorSizing: ConnectorSizing;
};

/**
 * A straight vertical line, intended to link two `AntibodyDomain`.
 * This is an SVG component, so all units are 'abstract user units', relative to the SVG viewbox.
 * @param domainVisualization The visualization for the straight line linker domain
 * @param connectorSizing The sizing params for this format's connectors
 * @param color The color of the line
 * @param proteinId The API ID of the protein entity associated with this domain. If passed, the linker will
 *                  be given a SmartChip-style popover with metadata about the protein.
 */
export default function AntibodyStraightLineLinker({
  domainVisualization,
  color,
  proteinId,
  inaccessible,
  connectorSizing,
}: AntibodyStraightLineLinkerProps): JSX.Element {
  const {centerLength} = domainVisualization;
  const {strokeThickness} = connectorSizing;
  // Draw a simple vertical line from (0, 0) to (0, centerLength)
  return (
    <AntibodyComponentPopover proteinId={proteinId} inaccessible={inaccessible}>
      <line x1={0} y1={0} x2={0} y2={centerLength} stroke={color} strokeWidth={strokeThickness} />
    </AntibodyComponentPopover>
  );
}
